import Vue from "vue"
import Vuetify from "vuetify/lib"

Vue.use(Vuetify, {
  iconfont: "mdi",
})

// Custom localization
import cs from "./localization"

export const palette = {
  navy: {
    darken1: "#100B42",
    base: "#595285",
    lighten1: "#B0ADBF",
    lighten2: "#D7D7E2",
    lighten3: "#F2F4FA",
    lighten4: "#F8F9FB",
  },
  navyGray: "#777486",
  indigo: {
    base: "#3126CC",
    lighten1: "#6A5EFE",
    lighten2: "#938CFB",
    lighten3: "#D0CAFF",
    lighten4: "#F4F3FF",
  },
  azure: {
    base: "#2BA7D9",
    lighten1: "#5ECEFA",
    lighten2: "#9DE2FF",
    lighten3: "#D9F4FF",
    lighten4: "#E9F9FE",
  },
  amber: {
    base: "#E79D41",
    lighten1: "#F9BB61",
    lighten2: "#FBD697",
    lighten3: "#FDECD0",
    lighten4: "#FEF4E4",
  },
  red: {
    base: "#CA3F25",
    lighten1: "#E06A54",
    lighten2: "#EE8673",
    lighten3: "#F5B2A6",
    lighten4: "#FBD9D2",
    lighten5: "#FDEDEF",
  },
  green: {
    base: "#1EAD1D",
    lighten1: "#6ACD6B",
    lighten2: "#99E29D",
    lighten3: "#B6EBBE",
    lighten4: "#DFF6EB",
  },
  facebook: "#3578E5",
}

export default new Vuetify({
  lang: {
    locales: { cs },
    current: "cs",
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: palette.navy.darken1,
        secondary: palette.azure,
        accent: palette.amber,
        anchor: palette.navy.darken1, // `a` tag color
        error: palette.red,
        info: palette.azure,
        success: palette.green,
        warning: palette.amber,

        ...palette,
      },
    },
  },
})
